export const SCOPE_NOTE_CALLOUT_BORDER_COLOR = "#CBD5E1";

export const CHAT_CALLOUT_CONTAINER_STYLE = [
  "width:100%",
  "box-sizing:border-box",
  `border:1px solid ${SCOPE_NOTE_CALLOUT_BORDER_COLOR}`,
  "background:transparent",
  "color:inherit",
  "border-radius:8px",
  "padding:12px",
  "margin:8px 0 12px 0",
  "font-weight:600",
].join(";");

export const INVESTIGATION_SUMMARY_CARD_STYLE = [
  "width:100%",
  "box-sizing:border-box",
  "border:1px solid #4285f4",
  "background:rgba(66,133,244,0.06)",
  "color:#3c4043",
  "border-radius:10px",
  "padding:12px 14px",
  "margin:8px 0 12px 0",
].join(";");

export const INVESTIGATION_SUMMARY_TITLE_STYLE = [
  "display:flex",
  "align-items:center",
  "gap:8px",
  "margin:0 0 8px 0",
  "font-weight:600",
  "font-size:14px",
  "color:#5f6368",
].join(";");

export const INVESTIGATION_SUMMARY_BODY_STYLE = [
  "font-size:14px",
  "line-height:1.55",
  "color:#3c4043",
].join(";");

export const CHOOSE_NEXT_STEP_CARD_STYLE = [
  "width:100%",
  "box-sizing:border-box",
  "border:1px solid #DADCE0",
  "background:#FAFBFF",
  "color:#3c4043",
  "border-radius:10px",
  "padding:12px 14px",
  "margin:10px 0 12px 0",
].join(";");
